import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
 
import { AuthGuard } from '~/core/classes/auth/auth.guard';
import { WellsPaInsightsComponent } from '~/pages/wells-pa-insights/wells-pa-insights';
import { MetricsComponent } from '~/pages/metrics/metrics';
 
//******************************************************************************
//  App Routes
//******************************************************************************
export const routes: any[] = [
    { path: '', component: WellsPaInsightsComponent },
    { path: 'prompt', component: WellsPaInsightsComponent, canActivate: [AuthGuard] },
    { path: 'metrics', component: MetricsComponent, canActivate: [AuthGuard] },
    { path: 'field/:sessionId', component: WellsPaInsightsComponent, canActivate: [AuthGuard] },
    { path: 'multiwell/:sessionId', component: WellsPaInsightsComponent, canActivate: [AuthGuard] },
    { path: 'well/:wellId/:sessionId', component: WellsPaInsightsComponent, canActivate: [AuthGuard] },
    { path: '**', redirectTo: '', pathMatch: 'full' },
];
 
@NgModule({
    imports: [
        RouterModule.forRoot(routes, { useHash: false })
    ],
    exports: [
        RouterModule
    ]
})
 
export class AppRouting { }